module.exports = __webpack_public_path__ + "static/chidozie-5415b848962485be93e28d7f35fbb7df.webp";